import { group as d3Group } from "d3-array";
import { html, TemplateResult } from "lit";
import { styleMap } from "lit/directives/style-map.js";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";
import _L from "../../../../util/Labels";
import { UIUtilTime } from "../../../util/Time";
import { ICargoRepeticion } from "../AlumnosCargosDescuentos";
import { _GetTotalSaldoByCargoRep } from "./calculations";
import ic_info from "/image/iconos/ic_infomark.svg?raw";

const dateFmt = UIUtilTime._DateFormatStandar;

export enum EInfoCargoMode {
    General,
    AplicarCargo,
}

export function _RenderAgruparAsignacionCargos(asignaciones: ICargoRepeticion[], mode: EInfoCargoMode = EInfoCargoMode.General): TemplateResult<1>[] {
    const asignacionesAgrupadas = d3Group<ICargoRepeticion, typeof asignaciones[0]["ParentAsignacion"]>(asignaciones, a => a.ParentAsignacion);

    const cardStyle = styleMap({
        "margin-bottom": "var(--padding2)",
        "padding": "var(--padding1)",
    });

    const liStyle = styleMap({
        "list-style-type": "none",
        "list-style-position": "inside",
        "margin": "var(--padding1) 0",
        "padding-left": "var(--padding1)",
        "display": "flex",
        "align-items": "center",
        "gap": "var(--padding1)",
    });

    const counterStyle = styleMap({
        "display": "inline-block",
        "width": "15px",
        "height": "15px",
        "line-height": "15px",
        "border-radius": "50%",
        "background-color": "var(--color-info)",
        "color": "var(--color_text4)",
        "text-align": "center",
        "flex": "none",
        "font-size": "var(--fontsize_me3)",
        "font-family": "Lato-Bold",
    });

    let count = 1;

    return Array.from(asignacionesAgrupadas, ([cargoAplicado, asignaciones]) => {
        return html`
        <div class="card" style=${cardStyle}>
            <p>
                <b>${_L("panelfinanzascargosdescuentos.tag_cargo")}:</b> <span>${cargoAplicado.Nombre}</span>
            </p>
            <ul style="padding: 0 var(--padding2);">
                ${asignaciones.map(rep => html`
                    <li style=${liStyle}>
                        <span style=${counterStyle}>${count++}</span>
                        ${renderAsignacionInfo(rep, mode)}
                    </li>
                `)}
            </ul>
        </div>`
    });
}

function renderAsignacionInfo(repeticion: ICargoRepeticion, mode: EInfoCargoMode): TemplateResult<1> {
    const noAplicado = mode === EInfoCargoMode.AplicarCargo && _GetTotalSaldoByCargoRep(repeticion) <= 0;

    const liContentBoldFontStyle = styleMap({
        "font-size": "var(--fontsize_me2)",
        "font-family": "Lato-Bold",
        "color": noAplicado ? "var(--color_app_red1)" : "inherit",
    });
    const liContentFontStyle = styleMap({
        "font-size": "var(--fontsize_me2)",
        "font-family": "Lato-Light",
        "color": noAplicado ? "var(--color_app_red1)" : "inherit",
    });

    const renderInfoIcon = noAplicado
        ? html`
        <div style="display: inline-block; width: 15px; height: 15px;">
            ${unsafeSVG(ic_info)}
        </div>`
        : null;

    return html`
    <div>
        <div>
            <span style=${liContentBoldFontStyle}>
                ${_L("panelfinanzascargosdescuentos.tag_periodo")}:
            </span>
            <span style=${liContentFontStyle}>
                ${dateFmt(repeticion.FechaInicio)} - ${dateFmt(repeticion.FechaFin)}
                ${renderInfoIcon}
            </span>
        </div>
        <div>
            <span style=${liContentBoldFontStyle}>
                ${_L("panelfinanzascargosdescuentos.tag_aplicacion")}:
            </span>
            <span style=${liContentFontStyle}>
                ${dateFmt(repeticion.Aplicacion)}
            </span>
        </div>

        ${noAplicado
            ? html`
                <wc-tooltip position="right" max-width="150px">
                    <span style="color:var(--color_app_red1);">
                        ${_L("panelfinanzascargosdescuentos.tag_noaplica")}
                    </span>
                    <br>${_L("panelfinanzascargosdescuentos.tag_cargocero")}
                </wc-tooltip>`
            : null
        }
    </div>
    `;
}